import { useState } from "react";
import { ShieldCheck } from "lucide-react";

// Official brand assets supplied by TC Auditors. Each logo is rendered at its
// natural aspect ratio with a height ceiling so the bar reads as a tidy row.
const TRUST_LOGOS = [
    {
        name: "Xero Gold Partner",
        src: "/assets/xero-gold-partner-badge.png",
        height: "h-16",
    },
    {
        name: "IRBA Registered Auditor",
        src: "/assets/irba-logo.jpg",
        height: "h-16",
    },
    {
        name: "Member of SAICA",
        src: "/assets/saica-logo.png",
        height: "h-20",
    },
    {
        name: "Chartered Accountants Worldwide — Network Member",
        src: "/assets/caw-logo.png",
        height: "h-20",
    },
];

function LogoBadge({ logo, isDark }) {
    const [errored, setErrored] = useState(false);
    if (errored) {
        return (
            <span
                title={logo.name}
                data-testid={`trust-logo-${logo.name.toLowerCase().replace(/\s/g, "-")}-fallback`}
                className={`inline-flex items-center px-4 ${logo.height} border ${
                    isDark ? "border-white/30 text-white" : "border-tca-line text-tca-ink"
                } font-display font-extrabold tracking-tight text-sm whitespace-nowrap`}
            >
                {logo.name}
            </span>
        );
    }
    return (
        <img
            src={logo.src}
            alt={logo.name}
            title={logo.name}
            loading="lazy"
            decoding="async"
            data-testid={`trust-logo-${logo.name.toLowerCase().replace(/\s/g, "-")}`}
            className={`${logo.height} w-auto object-contain transition-opacity duration-200 hover:opacity-100 ${
                isDark ? "" : "opacity-95"
            }`}
            onError={() => setErrored(true)}
        />
    );
}

export default function TrustBar({ variant = "light" }) {
    const isDark = variant === "dark";
    return (
        <section
            data-testid="trust-bar"
            className={`${isDark ? "bg-tca-ink text-white" : "bg-tca-fog"} border-y border-tca-line`}
        >
            <div className="container-tca py-10 md:py-12">
                <div className="flex flex-col items-center text-center gap-6 md:flex-row md:text-left md:items-center md:justify-between md:gap-10">
                    <div className="flex items-center gap-3 shrink-0">
                        <ShieldCheck className="w-5 h-5 text-tca-orange" />
                        <span
                            className={`overline ${isDark ? "text-white/60" : ""}`}
                            data-testid="trust-bar-tagline"
                        >
                            Regulated · Accredited · Trusted Since 2015
                        </span>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
                        {TRUST_LOGOS.map((l) => (
                            <LogoBadge key={l.name} logo={l} isDark={isDark} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
